
import { i18n } from "../../translate/i18n";// Regras puras da tela de Ajuda (/helps): categorias, destaque, busca,
// duração e progresso. Campos category/featured/duration/progress vêm do
// backend quando existirem; sem eles a tela degrada para "Geral"/primeiro.
export const DEFAULT_CATEGORY = "Geral";
const t = (k, o) => i18n.t(`aeros.helps.${k}`, o);

const norm = (s) => String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

export const categoryOf = (h) => (h?.category || "").trim() || t("general");

// Cores por categoria (ciclo estável pela ordem de aparição).
export const CATEGORY_COLORS = ["#22D3EE", "#C08BFF", "#34D399", "#FBBF24", "#F87171", "#7DD3FC"];
export const categoryColors = (helps) => {
  const map = {};
  (helps || []).forEach((h) => { const c = categoryOf(h); if (!(c in map)) map[c] = CATEGORY_COLORS[Object.keys(map).length % CATEGORY_COLORS.length]; });
  return map;
};

export const categoryPills = (helps) => {
  const counts = {};
  (helps || []).forEach((h) => { const c = categoryOf(h); counts[c] = (counts[c] || 0) + 1; });
  return [{ key: "", label: t("all"), n: (helps || []).length }, ...Object.keys(counts).map((c) => ({ key: c, label: c, n: counts[c] }))];
};

export const filterHelps = (helps, { category = "", search = "" } = {}) => {
  const q = norm(search).trim();
  return (helps || []).filter((h) => (!category || categoryOf(h) === category) && (!q || norm(`${h.title} ${h.description} ${categoryOf(h)}`).includes(q)));
};

export const featuredOf = (helps) => (helps || []).find((h) => h.featured) || (helps || [])[0] || null;

// "12:40" a partir de segundos; aceita string já formatada.
export const durationLabel = (d) => {
  if (d == null || d === "") return "";
  if (typeof d === "string" && d.includes(":")) return d;
  const s = Number(d); if (!s) return "";
  const m = Math.floor(s / 60), r = s % 60;
  return `${m}:${String(r).padStart(2, "0")}`;
};

export const progressPct = (h) => Math.max(0, Math.min(100, Number(h?.progress) || 0));

export const seenLabel = (h) => (h?.viewsCount != null && h?.usersCount ? t("seenBy", { seen: h.viewsCount, total: h.usersCount }) : "");

export const nextOf = (helps, current) => {
  const list = helps || [];
  const i = list.findIndex((h) => h.id === current?.id);
  return i >= 0 && i < list.length - 1 ? list[i + 1] : null;
};

export const youtubeId = (v) => {
  const s = String(v || "").trim();
  const m = s.match(/(?:v=|youtu\.be\/|embed\/)([A-Za-z0-9_-]{6,})/);
  return m ? m[1] : s;
};
